import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "@/store";

export const primaryRolesSelector = createSelector(
    [
        (state: RootState) => {
            return state.user.primaryCombinedRole.children;
        },
    ],
    (state) => {
        return state.filter((role) => role.type === "primary");
    },
);
